import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=7ff4934d&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"
import style0 from "./Slides.vue?vue&type=style&index=0&id=7ff4934d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4934d",
  null
  
)

export default component.exports